import { Alert, AlertIcon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const SupplierCountIndicator = ({
  selectedCount,
  maxParticipants,
}: {
  selectedCount: number;
  maxParticipants?: number;
}) => {
  const { t } = useTranslation();
  if (maxParticipants == null) return null;
  const overLimit = selectedCount > maxParticipants;
  const underLimit = selectedCount > 0 && selectedCount < maxParticipants;
  return (
    <Stack spacing="2">
      <Text fontSize="sm" color={overLimit ? "smError" : "smMuted"} px="1">
        {t("{{count}} of {{max}} suppliers selected", { count: selectedCount, max: maxParticipants })}
      </Text>
      {overLimit && (
        <Alert status="error" rounded="md" fontSize="sm">
          <AlertIcon />
          {t(
            "The framework agreement can have up to {{max}} suppliers, as the contract details state. Select no more than {{max}}.",
            { max: maxParticipants },
          )}
        </Alert>
      )}
      {underLimit && (
        <Alert status="info" rounded="md" fontSize="sm">
          <AlertIcon />
          {t(
            "The contract details allow up to {{max}} suppliers. You can award to fewer, and the framework agreement will have {{count}}.",
            { count: selectedCount, max: maxParticipants },
          )}
        </Alert>
      )}
    </Stack>
  );
};
